import {Component, Input, OnInit} from '@angular/core';
import {PrimaryContactInfoModel} from "../../domain/models/primary-contact-info.model";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatDivider} from "@angular/material/divider";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {FormValidationUtil} from "../../utils/form-validation.util";

@Component({
  selector: 'app-primary-contact-info-card',
  standalone: true,
    imports: [
        FormsModule,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardTitle,
        MatDivider,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        MatError,
        NgIf
    ],
  templateUrl: './primary-contact-info-card.component.html',
  styleUrl: './primary-contact-info-card.component.css'
})
export class PrimaryContactInfoCardComponent implements OnInit{
  @Input() model!: PrimaryContactInfoModel;
  form!: FormGroup;
  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.buildForm(this.model);
  }

  buildForm(info: PrimaryContactInfoModel): void {
    this.form = this.fb.group({
      primaryContactEmail: [info.primaryContactEmail?? '', [Validators.email, Validators.required]],
      primaryContactFirstName: [info.primaryContactFirstName?? '', Validators.required],
      primaryContactLastName: [info.primaryContactLastName?? '', Validators.required],
      primaryContactPhoneNumber: [info.primaryContactPhoneNumber?? '', [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]],
      printedName: [{value: info.printedName?? null, disabled:true}],
    });
  }

  getModelFromForm(): PrimaryContactInfoModel {
    return {
      primaryContactEmail: this.form.get('primaryContactEmail')?.value ?? null,
      primaryContactFirstName: this.form.get('primaryContactFirstName')?.value ?? null,
      primaryContactLastName: this.form.get('primaryContactLastName')?.value ?? null,
      primaryContactPhoneNumber: this.form.get('primaryContactPhoneNumber')?.value ?? null,
      printedName: this.form.get('printedName')?.value ?? null,
    };
  }

  isFormValid(): boolean {
    this.printInvalidControls();
    return this.form.valid;
  }

  printInvalidControls(){
    const controls = this.form.controls;

    for (const controlName in controls) {
      if (controls[controlName].invalid) {
        console.log("is invalid:", controlName);
      }
    }
  }

}
